import { FadeUp, MaskedReveal, SectionLabel } from "@/components/Motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function About() {
  return (
    <div className="pt-10 md:pt-16" data-testid="about-page">
      <section className="editorial-container">
        <SectionLabel number="No. 003" label="About" />
        <h1 className="mt-6 font-serif text-[13vw] sm:text-[9vw] md:text-[7vw] lg:text-[6rem] leading-[1] tracking-tight text-ink pb-4">
          <MaskedReveal text="Published" as="span" className="block" delay={0.1} animate />
          <MaskedReveal text="by post." as="span" className="block italic text-terracotta" delay={0.35} animate />
        </h1>
      </section>

      <section className="mt-16 md:mt-24 editorial-container">
        <div className="grid grid-cols-12 gap-x-6">
          <div className="col-span-12 md:col-span-8 md:col-start-3">
            <FadeUp>
              <p className="font-serif text-2xl md:text-3xl leading-[1.4] text-ink italic">
                The Safe Mama Editorial is a monthly print publication for the tender, complicated
                seasons of pregnancy and motherhood — delivered by post, in an envelope, to your door.
              </p>
            </FadeUp>
            <FadeUp delay={0.1}>
              <div className="mt-16 space-y-8 font-serif text-xl leading-[1.55] text-ink/80">
                <p>
                  We started this because everything else was moving too fast. Feeds designed to make
                  you anxious. Advice that felt like a slap. Wellness that felt like a sell. We wanted
                  something you could hold — something you could put on your bedside table and return
                  to on a slow Sunday morning.
                </p>
                <div>
                  <p>Each edition is small and considered:</p>
                  <ul className="mt-4 space-y-2 pl-6 list-disc marker:text-ink/40">
                    <li>An anonymous letter from a real mother</li>
                    <li>A Postcard from the Indian Kitchen, tailored to your stage</li>
                    <li>A nourishment weekly meal plan</li>
                    <li>A short note from a relevant expert</li>
                    <li>A thoughtful surprise — sometimes a sample, sometimes stationery or another small delight</li>
                  </ul>
                  <p className="mt-4">That is all. That is enough.</p>
                </div>
                <p>
                  We publish two editions — the Pregnancy Edition, for the expecting, and the
                  Motherhood Edition, for the after. Both contain the same categories of content,
                  adapted to the reader's stage.
                </p>
                <p>
                  We also run <em className="italic">The Reading Room</em> here on the web — a curated
                  library of pregnancy and motherhood writing from trusted publications. But the
                  anonymous letters — the softest thing we make — live only on paper. That, we
                  insist upon.
                </p>
                <p>The Safe Mama Editorial is a publication of Banyan Editorials — a small independent editorial studio.</p>
              </div>
            </FadeUp>

            <FadeUp delay={0.2}>
              <div className="mt-16 border-t border-ink/15 pt-10 flex items-end justify-between flex-wrap gap-6">
                <div>
                  <div className="overline text-ink/50">With warmth,</div>
                  <div className="mt-4 font-script text-5xl text-terracotta">Ikshiita Tewari</div>
                  <div className="mt-3 font-serif italic text-lg text-ink/70">Founder, Editor, Fellow Mama</div>
                </div>
                <Link to="/mail-club" className="btn-pill" data-testid="about-subscribe-cta">
                  Subscribe <ArrowUpRight size={14} />
                </Link>
              </div>
            </FadeUp>
          </div>
        </div>
      </section>
    </div>
  );
}
